module.exports = __webpack_public_path__ + "media/images/video_ecalls_thumb-ceafb7ee71701ccf589e2c170c53bde5.jpg";